// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__27MeH","dragIcon":"Choice_dragIcon__2oNTx","left":"Choice_left__3iomk","input":"Choice_input__32PoL"};